import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';
import { DatePickerInput } from 'components/shared/DatePickerInput';
import { Select } from 'components/shared/Select';

import { NO_SCHOOL_PREFIX_FILTER } from '../ActivationCodes.helpers';

import styles from './ActivationReportDateFilter.module.scss';

const ActivationReportDateFilter = ({
  activationFrom,
  activationTo,
  schoolPrefix,
  schoolPrefixOptions,
  prefixesLoading,
  onActivationFromChange,
  onActivationToChange,
  onSchoolPrefixChange,
}: {
  activationFrom: string;
  activationTo: string;
  schoolPrefix: string;
  schoolPrefixOptions: string[];
  prefixesLoading: boolean;
  onActivationFromChange: (value: string) => void;
  onActivationToChange: (value: string) => void;
  onSchoolPrefixChange: (value: string) => void;
}) => {
  const prefixSelectOptions = [
    {
      label: getTranslation(
        'school_page.activation_codes.date_filter.all_prefixes',
      ),
      value: '',
    },
    {
      label: getTranslation(
        'school_page.activation_codes.date_filter.no_prefix',
      ),
      value: NO_SCHOOL_PREFIX_FILTER,
    },
    ...schoolPrefixOptions.map((prefix) => ({
      label: prefix,
      value: prefix,
    })),
  ];

  const selectedPrefixOption =
    prefixSelectOptions.find((option) => option.value === schoolPrefix) ??
    prefixSelectOptions[0];

  return (
    <div className={styles.root}>
      <div className={styles.field}>
        <Typography
          className={styles.label}
          variant="caption"
          mode="compact"
        >
          {getTranslation(
            'school_page.activation_codes.date_filter.school_prefix',
          )}
        </Typography>
        <Select
          className={styles.select}
          loading={prefixesLoading}
          value={selectedPrefixOption}
          options={prefixSelectOptions}
          onChange={(selectedOption: { value: string } | null) =>
            onSchoolPrefixChange(selectedOption?.value ?? '')
          }
        />
      </div>
      <div className={styles.field}>
        <Typography
          className={styles.label}
          variant="caption"
          mode="compact"
        >
          {getTranslation('school_page.activation_codes.date_filter.from')}
        </Typography>
        <DatePickerInput
          className={styles.input}
          value={activationFrom ?? ''}
          onChange={onActivationFromChange}
        />
      </div>
      <div className={styles.field}>
        <Typography
          className={styles.label}
          variant="caption"
          mode="compact"
        >
          {getTranslation('school_page.activation_codes.date_filter.to')}
        </Typography>
        <DatePickerInput
          className={styles.input}
          value={activationTo ?? ''}
          onChange={onActivationToChange}
        />
      </div>
    </div>
  );
};

export default React.memo(ActivationReportDateFilter) as any;
